<script lang="ts">


    import {createEventDispatcher, onDestroy, onMount, tick} from "svelte";
    import {ImagePathConfig} from "../../../ImagePathConfig";

    const dispatcher = createEventDispatcher();

    enum Status {
        New,
        Loading,
        Loaded,
        Error,
    }

    // ローディング中の画像
    export let loadingSrc: string = ImagePathConfig.ImageView.loading;

    // 読み込みたい画像
    export let src: string = null;
    export let alt: string = '';

    // 読み込み失敗した場合のリロード回数/時間
    export let onErrorReloadMaxCount = 0; // エラー時のリロード回数
    export let reloadIntervalMilliSeconds = 3000;

    // サイズ
    export let widthPx = null;
    export let heightPx = null;

    $: style = (() => {
        const styleArray = [];
        if (widthPx != null) {
            styleArray.push(`width: ${widthPx}px;`);
        }
        if (heightPx != null) {
            styleArray.push(`height: ${heightPx}px;`);
        }

        const style = styleArray.join(';');
        return style;
    })();

    $: isShowImage = (() => {
        if (errorMessage != null) {
            return false;
        }
        switch (status) {
            case Status.Loaded:
                return true;
            default:
                return false;
        }
    })();

    $: isShowLoadingImage = (() => {
        if (errorMessage != null) {
            return false;
        }

        return !isShowImage;
    })();


    $: errorMessage = (() => {
        switch (status) {
            case Status.Error:
                return 'no image';
            default:
                return null;
        }
    })();

    let status: Status = Status.New;

    let reloadCount = 0;
    let previousSrc = null;


    let imageElement = null;
    let loadingImageElement = null;

    let isMounted = false;
    let isLoaded = false;


    let doDestroy = false;


    onMount(() => {


        imageElement.onload = () => {
            if (imageElement == null) {
                // 画面に imageElement が存在しなくなっている場合は処理しない
                return;
            }
            // imageElement.src = originalSrc;
            status = Status.Loaded;
            dispatcher('loaded');
        };
        imageElement.onerror = (e) => {
            if (doDestroy) {
                return;
            }
            // console.log('imageview onerror', {alt, onErrorReloadMaxCount, reloadCount, loadingSrc, originalSrcUrl, e});


            // エラー時のリロード回数が満たない場合は待機後に再リロードする
            reloadCount++;
            if (onErrorReloadMaxCount > reloadCount) {
                setTimeout(() => {
                    loadOriginalSrc();
                }, reloadIntervalMilliSeconds);
                return;
            }
            status = Status.Error;


        };

        isMounted = true;
    })

    onDestroy(() => {
        doDestroy = true;
        // console.log('ImageView.onDestroy');
        if (loadingImageElement != null) {
            loadingImageElement.src = '';
        }
        imageElement.src = '';
    })

    $: {
        if (isMounted) {
            if (src != previousSrc) {
                // src が変化した場合、画像を読み込む
                status = Status.New;

                // リロードカウントを初期化
                reloadCount = 0;

                // OriginalSrc を読み込む
                loadOriginalSrc();

                previousSrc = src;
            }

        }
    }


    /**
     * 最終的に表示したい画像を表示する
     */
    async function loadOriginalSrc() {
        // console.log({originalSrcUrl});

        if (imageElement == null) {
            return;
        }
        imageElement.src = '';
        await tick();

        if (src == null) {
            return;
        }
        // imageElement.src = null;

        // ローディングステータスに設定
        status = Status.Loading;

        await tick();


        // 画像を設定
        imageElement.src = src;
    }


</script>

<span class="image-view"
      style={style}
      data-src={src}
      class:loaded={status === Status.Loaded}
      class:error={errorMessage != null}
      on:click
>
    <img class="overlap img loading" alt={alt}
         bind:this={loadingImageElement}
         class:show={isShowLoadingImage}
         src={loadingSrc}
    />


    <img class="img" alt={alt}
         bind:this={imageElement}
         class:show={isShowImage}

    />
    {#if errorMessage != null}
        <span class="fill overlap error-message">
            { errorMessage }

        </span>
    {/if}


</span>


<style lang="scss">
    .image-view {
        width: 100%;
        height: 100%;

        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;


        > .overlap {
            position: absolute;
            left: 0;
            top: 0;
        }

        > .fill {
            width: 100%;
            height: 100%;
        }


        > .img {
            transition-duration: 0s;
            opacity: 0;
            max-height: 100%;
            max-width: 100%;

            &.loading {
                transition-duration: 1s;
                transform: scale(0.5);
                filter: grayscale(1);

            }

            &.show {
                transition-duration: 1s;
                opacity: 1;

                &.loading {
                    opacity: 0.25;
                }
            }

        }

        > .error-message {

            font-size: 0.5em;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0.5;
            user-select: none;
            text-align: center;
        }

        &.error {
            border-style: solid;
            border-width: 1px;
            border-color: #0002;

        }

    }
</style>